<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: "App",
  mounted() {
    //兼容iphone active 无效解决办法
    document.body.addEventListener("touchstart", function () {});

    function setRem() {
      // 设计稿以1920px为宽度，而我把页面宽度设计为10rem的情况下
      let baseSize = 192; // 这个是设计稿中1rem的大小。
      if(!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)){
        document.documentElement.style.fontSize = "200px"
      }else{
        // 移动端
        if (document.documentElement.clientWidth <= 992) {
          //  移动端 100px = 1rem
          baseSize = 100; // 这个是设计稿中1rem的大小。
          //   375为设计稿页面宽度，如为750，把375改为750
          const scale = document.documentElement.clientWidth / 375;
          // 设置页面根节点字体大小
          document.documentElement.style.fontSize =
              baseSize * Math.min(scale, 1) + "px";
        }
      }

    }

    let self = this;
    // 初始化
    setRem();
    // 窗口变化后，重置rem
    window.addEventListener(
        "resize",
        function (e) {
          self.$nextTick(() => {
            setRem();
          });
        },
        true
    );
  },
  methods: {

  }
};
</script>

<style lang="less">
@import "assets/css/style";
html,
body {
  padding: 0;
  margin: 0;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}
#app {
  min-height: calc(100vh + 1px);
}
* {
  font-family: Arial,Microsoft YaHei;
}
ul,li,img,p {
  padding: 0;
  margin: 0;
}
li{
  list-style: none;
}

.forPc(@content) {
  @media (max-width: 992px) {
    @content()
  }
}
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
.forWap(@content) {
  @media (min-width: 992px) {
    @content()
  }
}
</style>
